import React from 'react';
import styles from '../../WabaChats.module.scss';
import { API_URL_V2 } from '../../../../api';

export default function MediaPreview({ message, branchId }) {
    const { type, content } = message;
    if (!content) return null;

    // Build media URL from proxy endpoint if we have media_id
    const mediaUrl = content.media_url || (content.media_id && branchId ? `${API_URL_V2}/branches/${branchId}/waba/media/${content.media_id}` : null);

    switch (type) {
        case 'image':
            return mediaUrl
                ? <img src={mediaUrl} alt={content.caption || 'Image'} className={styles.mediaImage} loading="lazy" />
                : <div className={styles.mediaPlaceholder}>Image</div>;
        case 'video':
            return mediaUrl
                ? <video src={mediaUrl} controls className={styles.mediaVideo} />
                : <div className={styles.mediaPlaceholder}>Video</div>;
        case 'audio':
            return mediaUrl
                ? <audio src={mediaUrl} controls className={styles.mediaAudio} />
                : <div className={styles.mediaPlaceholder}>Audio</div>;
        case 'document':
            return (
                <div className={styles.mediaDocument}>
                    <span>{content.filename || 'Document'}</span>
                    {mediaUrl && <a href={mediaUrl} target="_blank" rel="noopener noreferrer">Download</a>}
                </div>
            );
        case 'sticker':
            return mediaUrl
                ? <img src={mediaUrl} alt="Sticker" className={styles.mediaSticker} loading="lazy" />
                : <div className={styles.mediaPlaceholder}>Sticker</div>;
        default:
            return null;
    }
}
